<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div>
          <div class="container">
            <div class="main-regionStatus">
              <div class="regionStatus-header">
                <h3 class="title">
                  <div class="item">
                    비 정상 현황
                  </div>
                </h3>
                <div class="date">
                  <div class="item">
                    {{ nowTime }}
                  </div>
                </div>
                <!--                <div class="object02" @click="openModal(null,null,true)">-->
                <!--                  비 정상 일괄 알림 발송-->
                <!--                </div>-->
              </div>
              <div class="regionStatus-body">
                <div class="tab">
                  <div class="web">
                    <ul class="list">
                      <li class="abnormalStatus">
                        <div class="item">
                          비 정상 현황
                        </div>
                      </li>
                      <li class="batteryCharge" @click="moveMenu('/RD002')">
                        <div class="item">
                          배터리 충전 필요 골프장
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="mobile">
                    <div class="formSelect" ref="select01">
                      <div class="formSelectList" @click="openSelect01">
                        <input type="text" value="비정상 현황" readonly />
                      </div>
                      <div class="formSelectPopup select01">
                        <div class="formSelectPopup-container">
                          <div class="outer">
                            <div class="inner">
                              <div class="formSelectPopup-box">
                                <div class="formSelectPopup-zone">
                                  <div class="formSelectPopup-header">
                                    <input
                                      type="text"
                                      placeholder="검색어를 입력하세요."
                                    />
                                  </div>
                                  <ul class="formSelectPopup-body">
                                    <li @click="closeSelectAll">
                                      <label>
                                        <input type="radio" />
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>비 정상 현황</span>
                                      </label>
                                    </li>
                                    <li>
                                      <label>
                                        <input type="radio" />
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>배터리 충전 필요 골프장</span>
                                      </label>
                                    </li>
                                  </ul>
                                  <div class="formSelectPopup-footer">
                                    <button class="formSelectPopup-cancel">
                                      취소
                                    </button>
                                    <!-- 비활성(Attribute) : disabled -->
                                    <button class="formSelectPopup-confirm">
                                      확인
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="select">
                  <div class="contain">
                    <div class="title">
                      {{ locationName + ' 비정상 현황' }}
                    </div>
                    <div class="content">
                      <div class="formSelect" ref="select02">
                        <div class="formSelectList" @click="openSelect02">
                          <input
                            type="text"
                            v-model="locationName"
                            placeholder="지역"
                            readonly
                          />
                        </div>
                        <div class="formSelectPopup select02">
                          <div class="formSelectPopup-container">
                            <div class="outer">
                              <div class="inner">
                                <div class="formSelectPopup-box">
                                  <div class="formSelectPopup-zone">
                                    <div class="formSelectPopup-header">
                                      <input
                                        type="text"
                                        placeholder="지역을 선택하세요."
                                      />
                                    </div>
                                    <ul class="formSelectPopup-body">
                                      <li
                                        v-for="locations in locationArr"
                                        :key="locations.name"
                                      >
                                        <label>
                                          <input
                                            type="radio"
                                            v-model="selectedLocation"
                                            :value="locations.code"
                                            v-on:change="confirmSelect02()"
                                          />
                                          <input type="checkbox" />
                                          <i></i>
                                          <span>{{ locations.name }}</span>
                                        </label>
                                      </li>
                                    </ul>
                                    <div class="formSelectPopup-footer">
                                      <button class="formSelectPopup-cancel">
                                        취소
                                      </button>
                                      <!-- 비활성(Attribute) : disabled -->
                                      <button class="formSelectPopup-confirm">
                                        확인
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="abnormalStatusInfo scroll-body">
                  <div class="header">
                    <ul class="list">
                      <li class="operation">
                        <div class="contain">
                          <div class="title">
                            전체
                          </div>
                          <div class="content">
                            {{ setupSumSe }}
                          </div>
                        </div>
                      </li>
                      <li class="normal">
                        <div class="contain">
                          <div class="title">
                            정상
                          </div>
                          <div class="content">
                            {{ activeSumSe }}
                          </div>
                        </div>
                      </li>
                      <li class="abnormal">
                        <div class="contain">
                          <div class="title">
                            비정상
                          </div>
                          <div class="content">
                            {{ inactiveSumSe }}
                          </div>
                        </div>
                      </li>
                      <li
                        class="normalOperationRate"
                        :class="setPercentageClass(activeSumSe, setupSumSe)"
                      >
                        <div class="contain">
                          <div class="title">
                            정상 가동률
                          </div>
                          <div class="content">
                            {{ calcPercentage(activeSumSe, setupSumSe) }}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <!-- 데이터 없을때(Class) : none -->
                  <div
                    class="body dev_headerLine"
                    :class="inactiveSumSe ? '' : 'none'"
                  >
                    <div class="table thead">
                      <!-- 헤더 고정 활성(Class) : active / x축 스크롤 이동 값(Style) : x축 스크롤 이동한 값 만큼 margin-left 마이너스 값 -->
                      <div class="fixed grid" style="margin-left: -0px;">
                        <div class="contain">
                          <table class="dev_aplList">
                            <colgroup>
                              <col class="club" />
                              <col class="course" />
                              <col class="normal" />
                              <col class="abnormal" />
                              <col class="holiday" />
                              <col class="normalOperationRate" />
                              <col class="notification" />
                              <col class="remark" />
                            </colgroup>
                            <thead>
                              <tr>
                                <th
                                  class="sort club name"
                                  @click="headerSort('name')"
                                >
                                  <div class="item">
                                    골프클럽
                                  </div>
                                </th>
                                <th
                                  class="sort course nhole"
                                  @click="headerSort('nhole')"
                                >
                                  <div class="item">
                                    코스
                                  </div>
                                </th>
                                <th
                                  class="sort normal activeCount"
                                  @click="headerSort('activeCount')"
                                >
                                  <div class="item">
                                    정상
                                  </div>
                                </th>
                                <th
                                  class="sort abnormal inactiveCount"
                                  @click="headerSort('inactiveCount')"
                                >
                                  <div class="item">
                                    비정상
                                  </div>
                                </th>
                                <th class="sort abnormal inactiveCount">
                                  <div class="item">
                                    휴장홀
                                  </div>
                                </th>
                                <th class="normalOperationRate">
                                  <div class="item">
                                    정상 가동률
                                  </div>
                                </th>
                                <th class="notification">
                                  <div class="item">
                                    알림
                                  </div>
                                </th>
                                <th class="remark">
                                  <div class="item">
                                    특이사항
                                  </div>
                                </th>
                              </tr>
                            </thead>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="table tbody">
                      <div class="contain">
                        <table>
                          <colgroup>
                            <col class="club" />
                            <col class="course" />
                            <col class="normal" />
                            <col class="abnormal" />
                            <col class="holiday" />
                            <col class="normalOperationRate" />
                            <col class="notification" />
                            <col class="remark" />
                          </colgroup>
                          <tbody>
                            <tr
                              v-for="clubAplInfo in MonitoringData"
                              :key="clubAplInfo.ccode"
                              @click="setCcodeMoveMenu(clubAplInfo.ccode)"
                              style="cursor: pointer;"
                            >
                              <td class="club">
                                <div class="item">
                                  {{ clubAplInfo.name }}
                                </div>
                              </td>
                              <td class="course">
                                <div class="item">
                                  {{ clubAplInfo.nhole }}
                                </div>
                              </td>
                              <td class="normal">
                                <div class="item">
                                  {{ clubAplInfo.activeCount }}
                                </div>
                              </td>
                              <td class="abnormal">
                                <div class="item">
                                  {{ clubAplInfo.inactiveCount }}
                                </div>
                              </td>
                              <td class="holiday">
                                <div class="item">
                                  {{ clubAplInfo.holidayHoleCount }}
                                </div>
                              </td>
                              <td class="normalOperationRate">
                                <div class="item">
                                  {{
                                    Percentage(
                                      clubAplInfo.activeCount,
                                      clubAplInfo.setupCount
                                    )
                                  }}
                                </div>
                              </td>
                              <!--                            <td class="notification" @click.stop="">-->
                              <!--                              <a :href="openSMS(clubAplInfo.ccode)" style="display: block; height: 37px;">-->
                              <!--                                <div class="item" style="margin-top: 10px;">-->
                              <!--                                  SMS-->
                              <!--                                </div>-->
                              <!--                              </a>-->
                              <!--                            </td>-->
                              <td
                                class="notification"
                                @click.stop="
                                  openModal(clubAplInfo.name, clubAplInfo.ccode)
                                "
                              >
                                <div class="item">
                                  SMS
                                </div>
                              </td>
                              <td class="remark">
                                <div class="item">
                                  {{ clubAplInfo.uniqueness }}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                          <tbody class="none">
                            <tr>
                              <td colspan="8">
                                데이터가 없습니다.
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th class="club">
                                합계
                              </th>
                              <th class="course">
                                {{ nHoleSumSe }}
                              </th>
                              <th class="normal">
                                {{ activeSumSe }}
                              </th>
                              <th class="abnormal">
                                {{ inactiveSumSe }}
                              </th>
                              <th class="holiday">
                                {{ holidaySumSe }}
                              </th>
                              <th class="normalOperationRate">
                                {{ perAverageSe }}
                              </th>
                              <th class="notification"></th>
                              <th class="remark"></th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="formSelectPopup select01">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select01">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="검색어를 입력하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li @click="closeSelectAll">
                      <label>
                        <input type="radio" checked />
                        <input type="checkbox" />
                        <i></i>
                        <span>비정상 현황</span>
                      </label>
                    </li>
                    <li @click="moveMenu('/RD002')">
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>배터리 충전 필요 현황</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select02">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select02">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="검색어를 입력하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="locations in locationArr" :key="locations.name">
                      <label>
                        <input
                          type="radio"
                          v-model="selectedLocation"
                          :value="locations.code"
                          v-on:change="confirmSelect02()"
                        />
                        <input type="checkbox" />
                        <i></i>
                        <span>{{ locations.name }}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select03">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select03">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="검색어를 입력하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="club in MonitoringData" :key="club.ccode">
                      <label>
                        <input
                          type="radio"
                          v-model="selectedCCode"
                          :value="club.ccode"
                          v-on:change="closeSelectAll()"
                        />
                        <input type="checkbox" />
                        <i></i>
                        <span>{{ club.name }}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal sms">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body">
                    <div class="select" v-if="!isSMSAll">
                      <div class="formSelect" ref="select03">
                        <div class="formSelectList" @click="openSelect03">
                          <input
                            type="text"
                            placeholder="선택하세요."
                            :value="getSelectedClubName(selectedCCode)"
                            readonly
                          />
                        </div>
                        <div class="formSelectPopup select03">
                          <div class="formSelectPopup-container">
                            <div class="outer">
                              <div class="inner">
                                <div class="formSelectPopup-box">
                                  <div class="formSelectPopup-zone">
                                    <div class="formSelectPopup-header">
                                      <input
                                        type="text"
                                        placeholder="검색어를 입력하세요."
                                      />
                                    </div>
                                    <ul class="formSelectPopup-body">
                                      <li
                                        v-for="club in MonitoringData"
                                        :key="club.ccode"
                                        @click="closeSelectAll"
                                      >
                                        <label>
                                          <input
                                            type="radio"
                                            v-model="selectedCCode"
                                            :value="club.ccode"
                                          />
                                          <input type="checkbox" />
                                          <i></i>
                                          <span>{{ club.name }}</span>
                                        </label>
                                      </li>
                                    </ul>
                                    <div class="formSelectPopup-footer">
                                      <button class="formSelectPopup-cancel">
                                        취소
                                      </button>
                                      <!-- 비활성(Attribute) : disabled -->
                                      <button class="formSelectPopup-confirm">
                                        확인
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="sms">
                      <textarea
                        placeholder="내용을 입력하세요."
                        :value="smsText"
                        maxlength="2000"
                        @input="inputText"
                      ></textarea>
                    </div>
                    <div class="byte">
                      <span>{{ sexyTextLength }}</span> / 2000 bytes
                    </div>
                  </div>
                  <div class="footer">
                    <button class="cancel" @click="closeAndCancelModal">
                      취소
                    </button>
                    <button class="confirm" @click="closeModal">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="alert typeConfirm">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body" v-html="alertMessage"></div>
                  <div class="footer">
                    <button class="cancel">
                      취소
                    </button>
                    <button class="confirm" @click="confirmAlert">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNowTimeFullYear } from '../../util/nowTime'
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'

import { ammService, settingService, userService } from '../../router'
import smsMixin from '../../features/sms/mixins/sms.mixin'
import { sendLmsMessage } from '../../features/sms/services/sms.service'

export default {
  name: 'RD001',
  mixins: [smsMixin],
  data() {
    return {
      beforeConfirm: true,
      alertBodyHTML: '',
      callback: null,
      sortColumn: '',
      sortType: '',
      MonitoringDataByRegion: {
        aplStatsClub: [],
        clubInfoList: []
      },
      MonitoringData: [],
      searchValue: '',
      regionCode: '',
      setupSum: 0,
      activeSum: 0,
      inactiveSum: 0,
      perAverage: 0,
      nHoleSumSe: 0,
      setupSumSe: 0,
      activeSumSe: 0,
      inactiveSumSe: 0,
      perAverageSe: 0,
      holidaySumSe: 0,
      locationId: 0,
      locationName: '',
      selectedLocation: '',
      locationArr: [
        { name: '전국', code: '0' },
        { name: '경기도/인천', code: '1' },
        { name: '충청북도', code: '10' },
        { name: '충청남도', code: '11' },
        { name: '전라도', code: '20' },
        { name: '경상북도', code: '30' },
        { name: '경상남도', code: '31' },
        { name: '강원도', code: '40' },
        { name: '제주도', code: '50' }
      ],
      smsText: '',
      smsTextLen: 0,
      smsBody: '',
      selectedCCode: '',
      selectedName: '',
      nowTime: null,
      isSMSAll: false,
      aplAllList: []
    }
  },
  created: function() {
    userService.getAll().then(response => {
      this.userInfo = response.data
      if (this.getCurrentLocationIdParam()) {
        this.locationId = this.getCurrentLocationIdParam()
      } else {
        this.locationId = '1'
      }
      this.locationName = this.locationArr.find(
        it => it.code === this.locationId
      ).name
      this.selectedLocation = this.locationId
    })
  },
  mounted: function() {
    this.setData()
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  computed: {
    sexyTextLength() {
      return this.extractTextBytes(this.smsText)
    }
  },
  methods: {
    setData: function() {
      ammService
        .getSummaryAplData2(this.searchValue)
        .then(response => {
          this.MonitoringDataByRegion = response.data
          this.resetData()
          this.nowTime = getNowTimeFullYear()
        })
        .catch(error => {
          console.log('getSummaryAplData2.err.===>', error)
        })
    },
    resetData: function() {
      this.allAplList = Object.keys(this.MonitoringDataByRegion.inactiveClub)
        .map(club => {
          const [ccode, name] = club.split('_')
          if (name === 'null') return false
          const holes = this.MonitoringDataByRegion.inactiveClub[club]
          const { idleCount, nhole, setupCount } = holes[0]
          return { ccode, name, holes, idleCount, nhole, setupCount }
        })
        .filter(club => club)
      this.MonitoringDataByRegion.clubInfoList.forEach(item => {
        const dataPath = this.allAplList.find(
          it => it.ccode.toString() === item.ccode
        )

        // Find statsClub by ccode.
        const foundStatsClub = this.MonitoringDataByRegion.aplStatsClub.find(
          ({ ccode }) => ccode == item.ccode
        )

        const offClub = this.isTodayOff(item)
        if (!dataPath) return
        if (offClub && !item.holiday_holes) return
        if (
          this.setRegionCode(item.ccode, item.region_code) !==
            Number(this.locationId) &&
          this.locationId !== '0'
        ) {
          return
        }
        const holidayHoles = item.holiday_holes || ''
        const holidayHolesArr = holidayHoles.split(',')
        const workHoles = dataPath.holes.filter(
          hole => !offClub || !holidayHolesArr.includes(String(hole.hlidx + 1))
        )
        const normalHolesCount = workHoles.filter(hole => hole.isActive).length
        if (normalHolesCount !== workHoles.length) {
          const __inactiveCount__ = workHoles.length - normalHolesCount

          this.nHoleSumSe += dataPath.nhole
          this.setupSumSe += workHoles.length
          this.activeSumSe += normalHolesCount
          this.inactiveSumSe += __inactiveCount__
          this.holidaySumSe += dataPath.holes.length - workHoles.length
          this.perAverageSe = this.Percentage(this.activeSumSe, this.setupSumSe)
          dataPath.setupCount = workHoles.length
          dataPath.activeCount = foundStatsClub.activeCount
          dataPath.inactiveCount = __inactiveCount__ || 0
          dataPath.holidayHoleCount = dataPath.holes.length - workHoles.length
          this.MonitoringData.push({ ...dataPath, ...item })
        }
        this.setupSum += workHoles.length
        this.activeSum += normalHolesCount
        this.inactiveSum += workHoles.length - normalHolesCount
        this.perAverage = this.Percentage(this.activeSum, this.setupSum)
      })
      this.sortColumn = 'name'
      this.sortType = 'asc'
      this.MonitoringData.sort(this.ascSort)
    },
    setCcodeMoveMenu: function(ccode) {
      localStorage.setItem('currentCcode', ccode)
      this.moveMenu('/CD002?ccode=' + ccode)
    },
    getCurrentLocationIdParam: function() {
      let currentLocationId = localStorage.getItem('CurrentLocationId')
      if (currentLocationId) {
        return currentLocationId
      } else {
        localStorage.setItem('CurrentLocationId', '1')
        return currentLocationId
      }
    },
    setSearchValue: function() {
      this.searchValue = this.regionCode
      this.setData()
    },
    headerSort: function(target) {
      if (
        document.querySelector('.dev_aplList thead tr th.ascending') !== null
      ) {
        document
          .querySelector('.dev_aplList thead tr th.ascending')
          .classList.remove('ascending')
      }
      if (
        document.querySelector('.dev_aplList thead tr th.descending') !== null
      ) {
        document
          .querySelector('.dev_aplList thead tr th.descending')
          .classList.remove('descending')
      }
      if (this.sortColumn === target) {
        if (this.sortType === 'asc') {
          this.sortType = 'desc'
          document
            .querySelector('.dev_aplList thead tr th.' + target)
            .classList.add('descending')
          this.MonitoringData.sort(this.descSort)
        } else {
          this.sortType = 'asc'
          document
            .querySelector('.dev_aplList thead tr th.' + target)
            .classList.add('ascending')
          this.MonitoringData.sort(this.ascSort)
        }
      } else {
        document
          .querySelector('.dev_aplList thead tr th.' + target)
          .classList.add('ascending')
        this.sortColumn = target
        this.sortType = 'asc'
        this.MonitoringData.sort(this.ascSort)
      }
    },
    getSelectedClubName(ccode) {
      const target = this.findSelectedClub(this.MonitoringData, ccode)
      return target ? target.name : ''
    },
    openModal: function(name, ccode, isSMSAll) {
      this.isSMSAll = isSMSAll
      this.selectedName = name
      this.selectedCCode = ccode
      this.smsText = `일부 홀에서 APL이 정상 작동하지 않습니다.
관제사이트 확인 하시어 조치 부탁 드립니다.`
      document.querySelector('body.type-content').classList.add('modalActive')
    },
    openSMS: function(cCode) {
      const telNumber =
        this.MonitoringData.find(it => it.ccode === String(cCode)).club_telno ||
        ''
      const smsBody = `
일부 홀에서 APL이 정상 작동하지 않습니다.%0D%0A
관제사이트 확인 하시어 조치 부탁 드립니다.
      `
      const smsSeparator = this.getSmsSeparator()
      const result = `sms:${telNumber}${smsSeparator}body=${smsBody}`
      console.log(result)
      return result
    },
    getSmsSeparator: function() {
      let ua = navigator.userAgent
      let uaindex
      let userOS
      let userOSver

      // determine OS
      if (ua.match(/iPad/i) || ua.match(/iPhone/i)) {
        userOS = 'iOS'
        uaindex = ua.indexOf('OS ')
      } else if (ua.match(/Android/i)) {
        userOS = 'Android'
        uaindex = ua.indexOf('Android ')
      } else {
        userOS = 'unknown'
      }

      // determine version
      if (userOS === 'iOS' && uaindex > -1) {
        userOSver = ua.match(/OS ([0-9]+)(_|.)[0-9]+/)[1]
      } else if (userOS === 'Android' && uaindex > -1) {
        userOSver = ua.substr(uaindex + 8, 3)
      } else {
        userOSver = 'unknown'
      }

      if (userOS === 'iOS') {
        if (Number(userOSver) >= 9) {
          return '&'
        } else {
          return ';'
        }
      } else {
        return '?'
      }
    },
    closeAndCancelModal: function() {
      document
        .querySelector('body.type-content')
        .classList.remove('modalActive')
    },
    closeModal: function() {
      document
        .querySelector('body.type-content')
        .classList.remove('modalActive')
      if (this.isSMSAll) {
        this.sendMSGAll()
        return
      }
      this.sendMSG(this.selectedCCode)
    },
    confirmSelect02: function() {
      this.locationId = this.selectedLocation
      this.locationName = this.locationArr.find(
        it => it.code === this.selectedLocation
      ).name
      localStorage.setItem('CurrentLocationId', this.locationId)
      this.MonitoringData = []
      this.setupSum = 0
      this.activeSum = 0
      this.inactiveSum = 0
      this.perAverage = 0
      this.nHoleSumSe = 0
      this.setupSumSe = 0
      this.activeSumSe = 0
      this.inactiveSumSe = 0
      this.perAverageSe = 0
      this.resetData()
      this.closeSelectAll()
    },
    sendMSG: async function(code) {
      const found = this.findSelectedClub(this.MonitoringData, code)
      const { club_telno: clubTelNo } = found
      const [ok, message] = await sendLmsMessage({
        numbers: [clubTelNo],
        message: this.smsText,
        bytes: this.extractTextBytes(this.smsText)
      })
      if (!ok) console.error('[sendMSG]', message)
      alert(message)

      // const telNumber = this.MonitoringData.find(it => it.ccode === String(cCode)).club_telno
      // const smsBody = this.smsText
      // if (!telNumber) {
      //   this.openAlert('담당자 연락처가 없습니다.')
      //   return
      // }
      // settingService.sendSMS({
      //   number: telNumber,
      //   message: smsBody.replaceAll('%0D%0A', '\n')
      // }).then(response => {
      //   if (response.statusCode === 200) {
      //     this.openAlert('SMS가 전송되었습니다.')
      //   }
      // }).catch(error => {
      //   console.log('sendSMS.err ===>', error)
      // })
    },
    sendMSGAll: function() {
      this.isSMSAll = false
      const numbers = this.MonitoringDataByRegion.clubInfoList
        .map(item => {
          let dataPath = this.MonitoringDataByRegion.aplStatsClub.find(
            it => it.ccode.toString() === item.ccode
          )
          if (!dataPath) return false
          if (this.isTodayOff(item)) return false
          if (!dataPath.inactiveCount) return false
          return item.club_telno
        })
        .filter(item => item)
      settingService
        .sendSMSGroup({
          numbers,
          message: this.smsText.replaceAll('%0D%0A', '\n')
        })
        .then(response => {
          if (response.statusCode === 200) {
            this.openAlert('문자가 전송되었습니다.')
          }
        })
        .catch(error => {
          console.log('sendSMS.err ===>', error)
        })
    },
    Percentage: function(data, sum) {
      return this.calcPercentage(data, sum)
    },
    inputText: function(e) {
      let tempText = e.target.value
      if (tempText.length >= 2000) {
        e.target.value = tempText.substr(0, 2000)
      }
      this.smsText = e.target.value
    },
    setPercentageClass: function(data, sum) {
      if (!sum) return 'normalOperationRate-100'
      if (!data) return 'normalOperationRate-20'
      const percentage = (data / sum) * 100
      if (percentage <= 0) return 'normalOperationRate-20'
      if (percentage > 100) return 'normalOperationRate-100'
      return `normalOperationRate-${Math.ceil(percentage / 20) * 20}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/regiondashboard/RD001.vue